import React, { useState } from "react";
import styled, { withTheme } from "styled-components";
import LightButton from "./LightButton";
import PropTypes from "prop-types";

const StyledButton = styled(LightButton)`
  position: relative;
`;

const LightExpandTitleButton = (props) => {
  const { text, cutAtChar = 5, onClick, ...rest } = props;

  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded(!expanded);

    if (onClick) {
      onClick();
    }
  };

  const expandedText = text || props.children;

  let printText = expandedText;

  if (expandedText.length > cutAtChar) {
    printText = expandedText.slice(0, cutAtChar - 4) + "...";
  }

  return (
    <StyledButton onClick={() => handleClick()} {...rest} text={text}>
      {expanded ? printText : expandedText}
    </StyledButton>
  );
};

LightExpandTitleButton.propTypes = {
  text: PropTypes.string,
};

export default withTheme(LightExpandTitleButton);
